


$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});

$(document).on("click", ".hk-mega-menu-toggle", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-mega-menu-toggle').removeClass('active');
    jQuery('.hk-mega-menu-toggle').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});




$(document).on("click", ".hk-element-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-option').removeClass('active');
$(this).addClass('active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.hk-product').find('.hk-quantity-data').hide();
$(this).parents('.hk-product').find('.hk-quantity-data[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", ".hk-sub-toggle.active", function(e) {
$(this).removeClass('active');
var sub_tab = 1;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});

$(document).on("click", ".hk-sub-toggle:not(.active)", function(e) {
$(this).addClass('active');
var sub_tab = 2;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});











$(document).on("click", ".hk-cart-button", function (e) {
  e.preventDefault();
    $('.hk-cart-drawer').addClass('active');
    $('.hk-drawer-cart-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-cart-close, .hk-drawer-cart-bg, a[href='#close_cart']", function (e) {
  e.preventDefault();
    $('.hk-cart-drawer').removeClass('active');
    $('.hk-drawer-cart-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

















function checkRequiredProductsInCart() {

  const requiredProductIds = [
    10433924202770,
    10433924366610,
    10433821671698,
    10440280178962
  ];

  return $.getJSON('/cart.js').then(function(cart) {

    const hasRequiredProduct = cart.items.some(function(item) {
      return requiredProductIds.includes(Number(item.product_id));
    });

    // Required product exists → continue normally
    if (hasRequiredProduct) {
      return;
    }

    // None of the required products exist → empty cart
    return $.ajax({
      type: 'POST',
      url: (window.Shopify.routes.root || '/') + 'cart/clear.js',
      dataType: 'json'
    });

  });
}


function refreshCartDrawer() {

  $('.hk-cart-drawer-js').addClass('hk-loading-cart');

  updateBundleSellingPlans()
    .then(function() {
      return updateBundleVariants();
    })
    .then(function() {
      return checkRequiredProductsInCart();
    })
    .then(function() {

      // Now fetch the FINAL updated cart HTML
      return $.get(window.location.href);

    })
    .then(function(response) {

      var newContent = $(response)
        .find('.hk-cart-drawer-js')
        .html();

      $('.hk-cart-drawer-js').html(newContent);

      updateCartCount();

hkUpdateDuplicateCartItems();
      document
        .querySelectorAll(
          '.hk-element-related-grid.hk-slick-slider[data-slider-config]'
        )
        .forEach(function(slider) {

          const config = JSON.parse(slider.dataset.sliderConfig);

          if (!$(slider).hasClass('slick-initialized')) {
            $(slider).slick(config);
          }

        });
hkUpdateDuplicateCartItems();
      $('.hk-cart-drawer-js').removeClass('hk-loading-cart');

    })
    .catch(function(error) {

      console.error('Cart refresh failed:', error);

      $('.hk-cart-drawer-js').removeClass('hk-loading-cart');

    });
}



function updateCartCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      var count = 0;
      cart.items.forEach(function (item) {
          count += item.quantity;
      });
      $('.hk-cart-count').text(count);
      if (count > 0) {
        $('.hk-cart-count').show();
      } else {
        $('.hk-cart-count').hide();
      }
      return count;
    })
    .catch(err => console.error('Cart count error:', err));
}

$(document).on('click', '.hk-cart-drawer-js .hk-quantity-plus, .hk-cart-drawer-js .hk-quantity-minus', function () {
    $('.hk-cart-drawer-js').addClass('hk-loading-cart');
  var $btn = $(this);
  var $wrapper = $btn.closest('.hk-line-item');
  var $input = $wrapper.find('.hk-quantity-input:not(.hk-quantity-input-fake)');

  var key = $wrapper.data('key');
  var qty = parseInt($input.val());

  if ($btn.hasClass('hk-quantity-plus')) {
    qty++;
  } else {
    qty--;
  }

  // update UI instantly
  $input.val(qty);

  // Shopify AJAX cart update
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    data: {
      id: key,
      quantity: qty
    },
    dataType: 'json',
    success: function (cart) {
        refreshCartDrawer();
    },
    error: function (err) {
      console.error('Cart update failed', err);
    }
  });
});




// remove item completely
$(document).on('click', '.hk-cart-drawer-js .hk-quantity-remove', function () {

  $('.hk-cart-drawer-js').addClass('hk-loading-cart');

  var $wrapper = $(this).closest('.hk-line-item');
  var variantId = Number($wrapper.data('variant-id'));

  $.getJSON('/cart.js')
    .done(function (cart) {

      var updates = {};

      // Find ALL cart lines with the same variant_id
      cart.items.forEach(function (item) {

        if (Number(item.variant_id) === variantId) {
          updates[item.key] = 0;
        }

      });

      // Nothing found
      if (!Object.keys(updates).length) {
        $('.hk-cart-drawer-js').removeClass('hk-loading-cart');
        return;
      }

      // Remove all matching lines in one request
      $.ajax({
        url: (window.Shopify.routes.root || '/') + 'cart/update.js',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          updates: updates
        }),
        dataType: 'json'
      })
      .done(function () {

        refreshCartDrawer();

      })
      .fail(function (err) {

        console.error('Remove failed', err);
        $('.hk-cart-drawer-js').removeClass('hk-loading-cart');

      });

    })
    .fail(function (err) {

      console.error('Cart fetch failed', err);
      $('.hk-cart-drawer-js').removeClass('hk-loading-cart');

    });

});




$(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this).addClass('hk-loading');
  var items = [];
  var variant_id =  $(this).attr('variant_id');
  var Item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(Item);
  // Single call to /cart/add.js
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: items }),
    dataType: 'json',
    contentType: 'application/json',
    success: function () {
    },
    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
      refreshCartDrawer();
    $('.hk-cart-drawer').addClass('active');
    $('.hk-drawer-cart-bg').show();
    $('body').addClass('hk-overflow-hidden');
      }, 500);
    }
  });
});


function updateBundleSellingPlans() {

  const defaultVariantConfigs = {
    1: 695015506194,
    2: 695015538962,
    3: 695015571730,
    '3+': 695017996562
  };

  const usVariantConfigs = {
    1: 695015604498,
    2: 695015637266,
    3: 695015670034,
    '3+': 695018029330
  };

  const sellingPlanConfigs =
    Shopify.country === 'US'
      ? usVariantConfigs
      : defaultVariantConfigs;



  function processNext() {

    return $.getJSON(
      (window.Shopify.routes.root || '/') + 'cart.js'
    ).then(function(cart) {

      /*
       * Calculate the total quantity of ALL subscription items,
       * regardless of product or variant.
       */
      const totalSubscriptionQty = cart.items.reduce(function(total, item) {

        if (!item.selling_plan_allocation) return total;

        return total + item.quantity;

      }, 0);

      /*
       * No subscription items in the cart.
       */
      if (totalSubscriptionQty === 0) {
        return Promise.resolve();
      }

      /*
       * Determine the correct selling plan based on the
       * combined subscription quantity.
       */
      const targetPlan =
        totalSubscriptionQty >= 4
          ? sellingPlanConfigs['3+']
          : sellingPlanConfigs[totalSubscriptionQty];

      if (!targetPlan) {
        return Promise.resolve();
      }

      /*
       * Find ONE subscription line with an incorrect plan.
       */
      let updateItem = null;
      let updateLine = null;

      cart.items.some(function(item, index) {

        // Skip one-time purchase items.
        if (!item.selling_plan_allocation) return false;

        const currentPlan =
          item.selling_plan_allocation.selling_plan.id;

        if (String(currentPlan) !== String(targetPlan)) {

          updateItem = item;
          updateLine = index + 1;

          return true;
        }

        return false;

      });

      /*
       * All subscription lines already have the correct plan.
       */
      if (!updateItem) {
        return Promise.resolve();
      }

      /*
       * Update one line, then re-fetch the cart and repeat.
       */
      return $.ajax({
        type: 'POST',
        url: (window.Shopify.routes.root || '/') + 'cart/change.js',
        data: {
          line: updateLine,
          quantity: updateItem.quantity,
          selling_plan: targetPlan
        },
        dataType: 'json'

      }).then(function() {

        return processNext();

      });

    });

  }

  return processNext().catch(function(error) {

    console.error(
      'Selling plan update failed:',
      error.responseJSON || error.responseText || error
    );

    throw error;

  });

}

function updateBundleVariants() {

  /*
   * Each array contains the four option variants for that quantity tier.
   * The option index is preserved when switching tiers.
   */
  const variantTiers = {
    1: [
      52710410584338,
      52710410617106,
      52710410649874,
      52710410682642
    ],

    2: [
      52710521962770,
      52710521995538,
      52710522028306,
      52710522061074
    ],

    3: [
      52710522487058,
      52710522519826,
      52710522552594,
      52710522585362
    ],

    4: [
      52728432886034,
      52728432918802,
      52728432951570,
      52728432984338
    ]
  };

  /*
   * Build a lookup for all configured variants.
   * Each variant maps to its option index and quantity tier.
   */
  const variantLookup = {};

  Object.keys(variantTiers).forEach(function(tier) {

    variantTiers[tier].forEach(function(variantId, optionIndex) {

      variantLookup[variantId] = {
        tier: Number(tier),
        optionIndex: optionIndex
      };

    });

  });

  function processNext() {

    return $.getJSON(
      (window.Shopify.routes.root || '/') + 'cart.js'
    ).then(function(cart) {

      const managedItems = [];

      let totalQuantity = 0;

      /*
       * Collect all configured one-time purchase items.
       * Subscription items and unrelated products are ignored.
       */
      cart.items.forEach(function(item) {

        if (item.selling_plan_allocation) return;

        const config = variantLookup[item.variant_id];

        if (!config) return;

        managedItems.push({
          item: item,
          optionIndex: config.optionIndex
        });

        totalQuantity += item.quantity;

      });

      /*
       * Nothing to process.
       */
      if (totalQuantity === 0) {
        return;
      }

      /*
       * Select the tier based on total quantity across
       * ALL configured variants.
       *
       * Quantity 1 -> Tier 1
       * Quantity 2 -> Tier 2
       * Quantity 3 -> Tier 3
       * Quantity 4+ -> Tier 4
       */
      const targetTier = Math.min(totalQuantity, 4);

      const targetVariants = variantTiers[targetTier];

      /*
       * Determine whether any variant needs conversion.
       */
      let needsUpdate = false;

      managedItems.forEach(function(entry) {

        const currentVariantId = entry.item.variant_id;

        const targetVariantId =
          targetVariants[entry.optionIndex];

        if (Number(currentVariantId) !== Number(targetVariantId)) {
          needsUpdate = true;
        }

      });

      /*
       * All variants are already correct.
       */
      if (!needsUpdate) {
        return;
      }

      /*
       * Remove all managed lines first.
       * Preserve quantities and line-item properties for re-adding.
       */
      const updates = {};

      const itemsToAdd = managedItems.map(function(entry) {

        const item = entry.item;

        updates[item.key] = 0;

        return {
          id: targetVariants[entry.optionIndex],
          quantity: item.quantity,
          properties: item.properties || {}
        };

      });

      /*
       * Remove old variants.
       */
      return $.ajax({
        type: 'POST',
        url: (window.Shopify.routes.root || '/') + 'cart/update.js',
        contentType: 'application/json',
        data: JSON.stringify({
          updates: updates
        }),
        dataType: 'json'

      }).then(function() {

        /*
         * Add all items back using the correct tier variants.
         */
        return $.ajax({
          type: 'POST',
          url: (window.Shopify.routes.root || '/') + 'cart/add.js',
          contentType: 'application/json',
          data: JSON.stringify({
            items: itemsToAdd
          }),
          dataType: 'json'
        });

      }).then(function() {

        /*
         * Verify the resulting cart.
         * If Shopify merged lines, the next pass will handle that.
         */
        return processNext();

      });

    });

  }

  return processNext().catch(function(error) {

    console.error(
      'Bundle variant update failed:',
      error.responseJSON || error.responseText || error
    );

    throw error;

  });

}



















jQuery(document).ready(function() {
    var shipping_price = $('.hk-free-ship-bar').attr('shipping_price');

    $('.hk-header-text1 p').html(function(_, text) {
        return text.replace('[shipping_price]', shipping_price);
    });
});


$(document).on("click", ".hk-filter-list1-item", function (e) {
    $('.hk-filter-list1-item').removeClass('hk-active');
    $(this).addClass('hk-active');
    var tab_index = $(this).index() + 1;
    $('.hk-tab').removeClass('hk-active');
    $('.hk-tab'+tab_index).addClass('hk-active');
});



$(window).on('load', function () {
    $('.hk-hp-reviews-slider .hk-slick-slider').slick('setPosition');
});




$(document).ready(function () {
    if ($('.hk-popup-tabs-main ul li').length) {
        $('.hk-popup-tabs-main ul li').first().addClass('hk-active');
    }
});

$(document).on("click", ".hk-popup-tabs-main ul li", function (e) {
    $('.hk-popup-tabs-main ul li').removeClass('hk-active');
    $(this).addClass('hk-active');
    var tab_index = $(this).index() + 1;
    $('.hk-pdp-popup-tab').removeClass('hk-active');
    $('.hk-pdp-popup-tab'+tab_index).addClass('hk-active');
});




function hkUpdateDuplicateCartItems() {
  const seenVariants = new Set();

  document.querySelectorAll(
    '.hk-line-item-grid .hk-line-item[data-variant-id]'
  ).forEach(function(item) {

    const variantId = item.dataset.variantId;

    if (seenVariants.has(variantId)) {
      item.classList.add('hk-hide-item');
    } else {
      seenVariants.add(variantId);
      item.classList.remove('hk-hide-item');
    }

  });
}

// Run on initial page load
$(document).ready(function() {
  hkUpdateDuplicateCartItems();
});